export const en = {
  helpGuideHeader: 'Not sure which plan is right?',
  helpGuideMessage:
    "Tell us your team size and number of client sites — we'll help you choose.",
  helpGuideMessagePricingLink: 'For a more detailed breakdown of each plan, view the',
  helpGuideMessagePricingLinkText: 'pricing page',
  helpGuideChatWithUs: 'Chat with us',
  paymentExtension: (expiresAt: string) =>
    `Note: you currently have an extension on your payment until ${expiresAt}`,
  canceled: 'Your plan has been cancelled.',
  cancelling: (renewalDate: string) =>
    `Note: Your subscription is set to cancel on ${renewalDate} unless you reactivate`,
  updatePaymentDetails: 'update your payment details',
  contactUs: 'contact us',
  overdue: 'Your account is currently overdue. Please reactivate below',
  expired: 'Your account has expired, please',
  trailing: (expiresAt: string) =>
    `Your trial ends on ${expiresAt}. Choose a plan to keep your projects and client feedback uninterrupted.`, // <%= @organization.user.trial_expiry_date.strftime("%e %B %Y") %>.
  trialExpired:
    'Your free trial has now expired but all you have to do is pick a plan and you can continue on your way!',
  currentPlanIsPaused: (price: number) =>
    `Your current plan is paused at $${price}/mo`,
  additionalUsersBody: (price: number) =>
    `Add more members to your current plan for just $${price} per user.`,
  additionalUsersHeader: 'Just need a few more users?',
  addMembers: 'Add member(s)',
  havingTrouble: 'Having trouble deciding?',
  getInTouch: 'Get in-touch',
  currentPlan: (couponDescription: string) =>
    `${couponDescription} has been applied to your subscription`,
  planCallout: 'Upgrade to a Plan that works for you',
  pricing2026VariantPlanCallout: 'Choose the plan that works best for your team',
  pricingDisclaimerMonthly: (price: number) =>
    `Prices are shown in USD. Additional member(s) available for $${price} per user (billed monthly).`,
  pricingDisclaimerYearly: (price: number) =>
    `Prices are shown in USD. Additional member(s) available for $${price} per user (billed annually).`,
  planCalloutSubtext:
    'All plans include unlimited projects and clients. You only pay for your team.',
  pricing2026VariantPlanCalloutSubtext: (price: number) =>
    `Basic and Pro include 5 members, plus $${price} per additional member.`,
  annualSavings: '(2 months free with annual plans)'
};

export type Translations = typeof en;
